export const VirtualOfficeLogoWhiteIcon = () => {
  return (
    <svg
      width="30"
      height="24"
      viewBox="0 0 30 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2126 7.22236C15.9611 14.2892 18.8773 23.9903 29.3269 23.9903V14.6002C29.3269 14.6002 15.0765 15.5043 15.0765 0H14.2503C14.2503 15.5043 0 14.6002 0 14.6002V23.9903C10.4496 23.9903 13.3657 14.2892 14.1142 7.22236H15.2224H15.2126Z"
        fill="white"
      />
    </svg>
  );
};
